import apiRequest from "./apiClient";

export async function fetchOrders({ page = 0, size = 10, status, search, userId, buyerId } = {}) {
  const params = new URLSearchParams({ page, size });
  if (status) params.set("status", status);
  if (search) params.set("search", search);
  if (userId) params.set("userId", userId);
  if (buyerId) params.set("buyerId", buyerId);
  const body = await apiRequest(`/api/v1/admin/orders?${params}`);
  return body.data;
}

export async function fetchOrderTimeline(orderId) {
  const body = await apiRequest(`/api/v1/tracking/timeline/${orderId}`);
  return body.data;
}

export async function fetchOrderById(orderId) {
  const body = await apiRequest(`/api/v1/admin/orders/${orderId}`);
  return body.data;
}

export async function fetchAssignmentOptions(orderId) {
  const body = await apiRequest(`/api/v1/admin/orders/${orderId}/assignment-options`);
  return body.data;
}

export async function assignOrder(orderId, buyerId) {
  const body = await apiRequest(
    `/api/v1/admin/orders/${orderId}/assign?buyerId=${buyerId}`,
    { method: "PUT" }
  );
  return body.data;
}

export async function cancelOrder(orderId, reason) {
  const body = await apiRequest(
    `/api/v1/admin/orders/${orderId}/cancel?reason=${encodeURIComponent(reason)}`,
    { method: "PUT" }
  );
  return body.data;
}
